<template>
  <div 
    class="card" 
    @mouseenter="hoverId = item.codigo"
    @mouseleave="hoverId = null"
    :style="{
      width: '200px',
      'background-color': settings.layout['color1'] || '#F0F8FF'
    }"
  >
    <div
      ref="current-speaker"
      class="speaker-img"
      :style="{
        '--zoom-size': `${settings.layout.zoom || '125'}%`,
        backgroundImage: `url('${item.url_avatar}')`,
      }"    
    ></div>
    <div 
      :class="['d-flex flex-column flex justify-center px-4', {'pt-0': item.linkedin}]"
      style="height: 110px"    
    >
      <section
        :style="{
          transition: 'all 0.5s ease',
          height: item.linkedin && (settings.layout.linkedinIcon || hoverId === item.codigo)  ? '70px': '48px',
        }"
      >
        <span 
          class="titleCard" 
          :style="{
            color: settings.layout['text-color1'] || '#24252D', 
            fontSize: item.nome.length > 15 ? '18px': '20px'
          }"
        >
        {{formatedName}}
        </span>

        <v-tooltip bottom max-width="220" :disabled="!infoTooltip" :color="settings.layout['tooltip-color']">
          <template v-slot:activator="{ on }">
            <span 
              v-on="on"
              ref="info-speaker"
              class="subtitleCard" 
              :style="{
                color: settings.layout['text-color2'] || '#666D80'
              }"
            >
              {{ getSpeakerInfo }}
            </span>
          </template>
          <div :style="{'font-size': '0.8rem'}">
            <span class="d-block pb-2">
              <b :style="{color: settings.layout['tooltip-text-color'] || '#FFFFFF', 'font-weight': '900'}">
                {{ item.cargo }}
              </b>
            </span>

            <span class="d-block" :style="{color: settings.layout['tooltip-text-color'] || '#FFFFFF'}">
              {{ item.empresa }}
            </span>
          </div>
        </v-tooltip>

        <div
          v-if="item.linkedin && (settings.layout.linkedinIcon || hoverId === item.codigo)"
          :class="['linkedin text-center pt-1']"
        >
          <v-btn fab color="transparent" class="elevation-0" x-small @click.stop="$emit('onClickLinkedin', item)">
            <v-icon color="bt_color" size="24">fa-brands fa-linkedin</v-icon>
          </v-btn>
        </div>
      </section>
    </div>
  </div>
</template>

<script>

export default {
  props: ["item", "settings"],
  computed: {
    getBoxShadow () {
      const shadow = this.settings.layout.shadow
      const distance = this.settings.layout.distance
      if (shadow) return `${distance}px ${distance}px 0 1px ${shadow}`
      else return 'none'
    },

    formatedName () {
      const originalName = this.item.nome
      const splitName = originalName.split(' ')
      let formatedName = ''
      if (splitName.length > 3) formatedName = `${splitName[0]} ${splitName[1]}`
      else formatedName = originalName
      
      return formatedName
    },

    getSpeakerInfo () {
      if (this.settings.layout.companyPosition) return `${this.item.cargo} - ${this.item.empresa}`
      else return this.item.empresa
    }    
  },

  data: () => ({
    hoverId: null,
    infoTooltip: false
  }),

  watch: {
    hoverId (id) {
      const currentSpeaker = this.$refs['current-speaker']
      if (id === this.item.codigo) {
        currentSpeaker.style.backgroundSize = `auto var(--zoom-size) !important`
        const infoSpeaker = this.$refs['info-speaker']
        const isInfoSpeakerEllipsed = infoSpeaker.scrollHeight > infoSpeaker.clientHeight
        this.infoTooltip = isInfoSpeakerEllipsed
      } else {
        currentSpeaker.style.backgroundSize = `auto 100%`
        this.infoTooltip = false
      }
    }
  }
};
</script>

<style scoped>
.card {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  width: 200px;
  max-width: 200px;
  border-radius: 32px;
  transition: all 1s;
  padding-bottom: 12px;
}

.card:hover {
  cursor: pointer;
  transform: translateY(-8px);
}

.speaker-img {
  transition: all 0.5s;
  border-radius: 32px;
  width: 200px;
  height: 200px;
  background-position: center;
  background-size: auto 100%;
}

.speaker-img:hover {
  cursor: pointer;
  background-size: auto var(--zoom-size) !important;
}

span {
  display: block;
}

.titleCard {
  font-size: 20px;
  font-style: normal;
  font-weight: 900;
  letter-spacing: 0px;
  line-height: 19px;
  text-align: center;
  overflow: hidden; 
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  text-overflow: ellipsis;
  max-height: 100%; 
  padding-bottom: 4px; 
}

.subtitleCard {
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  text-align: center;
  line-height: 18px;
  overflow: hidden; 
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  text-overflow: ellipsis;
  max-height: 100%;
  color: #666D80
}

.linkedin {
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: center;
  justify-content: start;
  animation: _fadeIn 0.5s;
}
</style>
